module.exports = __webpack_public_path__ + "img/ayalda_anda_yes.1c130ba9.png";